import styled from "styled-components";
import {Space} from "antd";

export const StyledDataContainer = styled(Space).attrs({
	direction: "vertical",
})`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
	width: 95%;
	margin-left: auto;
	text-align: start;
`;
